import { frontendURL } from '../../../helper/URLHelper';
import MeuAluguelIndex from './pages/MeuAluguelIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/meu-aluguel'),
    alias: [
      frontendURL('accounts/:accountId/rent-offer/details'),
      frontendURL('accounts/:accountId/aluguel'),
    ],
    name: 'lais_meu_aluguel_index',
    component: MeuAluguelIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/meu-aluguel/:offerId'),
    alias: [frontendURL('accounts/:accountId/rent-offer/:offerId/details')],
    name: 'lais_meu_aluguel_detail',
    component: MeuAluguelIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/meu-aluguel/:offerId/:section'),
    alias: [
      frontendURL('accounts/:accountId/rent-offer/:offerId/:section'),
      frontendURL('accounts/:accountId/rent-offer/closing/:offerId/:section'),
    ],
    name: 'lais_meu_aluguel_detail_section',
    component: MeuAluguelIndex,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
